import { render, staticRenderFns } from "./FinishInitialSettingsTutorialModal.vue?vue&type=template&id=5c34b283&scoped=true&"
import script from "./FinishInitialSettingsTutorialModal.vue?vue&type=script&lang=js&"
export * from "./FinishInitialSettingsTutorialModal.vue?vue&type=script&lang=js&"
import style0 from "./FinishInitialSettingsTutorialModal.vue?vue&type=style&index=0&id=5c34b283&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c34b283",
  null
  
)

export default component.exports